import React, { useEffect } from 'react';
import clsx from 'clsx';
import { ServiceDialog,NameTextField } from '../../styling/Styles'
import apiService from '../../services/apiService';

const SimpleLoginPopUp = (props) =>{

    const{
        openAlert,
        setOpenAlert,
        setData,
        dispatch
    }=props;

    const [password, setPassword] = React.useState('');
    const [userName,setUserName] = React.useState('');

    useEffect( () => {
        if(openAlert === true){
            setPassword('');
            setUserName('');
        }
    },[openAlert])

    function handleSubmit() {
        // if (!e.target.elements.password.value)
          // return setData({ isLoading: false, errorMessage: 'Password is needed' });
        // if (!e.target.elements.username.value)
          // return setData({ isLoading: false, errorMessage: 'Username is needed' });
        setOpenAlert(false);
        apiService
          .loginWithUserPass({
            password,
            username: userName
            })
          .then((user) =>
            dispatch({
              type: 'LOGIN',
              payload: {
                user,
                isLoggedIn: true
              }
            })
          )
          .catch((error) => {
            throw(error);
            // setData({ isLoading: false, errorMessage: 'Sorry! Login failed' });
          });
        
        return 'true';
      }

    const closePasswordPopUp = () => {
        setData({ isLoading: false, errorMessage: '' });
        setOpenAlert(false);
    }

    const handleUserName = (val) => {
        setUserName(val.target.value);
    }

    const handlePassword = (val) => {
        setPassword(val.target.value);
    }

    return(
            <ServiceDialog
                open={openAlert}
                keepMounted
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            > 
                 <div className={clsx('titlePopUp','paddingTitle')} style={{minWidth: 0}}> Workshop&apos;s Account</div>
                 <div className ='paddingTitle'>
                        <div className={clsx('spacingTopDiv')} style={{display: 'flex', justifyContent: 'center',flexDirection: 'column'}}>
                            
                            
                                <div>
                                    <span>User name: &nbsp; </span>
                                    <div style={{ display: 'inline-flex', paddingTop: '0.5vw', marginLeft: '2vw' }}>
                                    
                                    <NameTextField
                                        required
                                        fullWidth
                                        id="username"
                                        name="username"
                                        autoComplete="username"
                                        autoFocus
                                        placeholder = " user name"
                                        onInput={(e) => handleUserName(e)}
                                        value={userName}
                                    />
                                    </div>
                                </div>

                                <div style={{marginTop: '0.5vw'}}>
                                    <span>Password: &nbsp; </span>
                                    <div style={{ display: 'inline-flex', paddingTop: '0.5vw', marginLeft: '2.7vw' }}>
                                    
                                    <NameTextField
                                        margin="normal"
                                        required
                                        fullWidth
                                        name="password"
                                        type="password"
                                        id="password"
                                        autoComplete="current-password"
                                        placeholder= ' password'
                                        onInput={(e) => handlePassword(e)}
                                        value={password}
                                    />
                                    </div>
                                </div>
                                
                                <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: '1vw'}}>
                                    <button
                                    type='button'
                                    style={{
                                        backgroundColor: '#e83c52',
                                        borderRadius: '8px',
                                        borderColor: '#e83c52',
                                        borderStyle: 'solid',
                                        color: '#fff',
                                        display: 'flex',
                                        alignSelf: 'center',
                                        fontFamily: 'Open Sans',
                                        cursor: 'pointer',
                                        textDecoration: 'none',
                                        justifyContent: 'center',
                                        textTransform: 'none',
                                        paddingLeft: '0.1rem',
                                        paddingRight: '0.1rem',
                                        paddingTop: '0.3rem',
                                        paddingBottom: '0.3rem',
                                        width: '10vw'
                                    }}
                                    onClick={handleSubmit}
                                    >
                                    <span id='simpleSignInButton' style={{ fontSize: '1vw', whiteSpace: 'nowrap' }}>Sign In</span>
                                    </button>

                                    <button
                                    type='button'
                                    style={{
                                        backgroundColor: '#fff',
                                        borderRadius: '8px',
                                        borderColor: '#0c4d82',
                                        borderStyle: 'solid',
                                        color: '#0c4d82',
                                        display: 'flex',
                                        alignSelf: 'center',
                                        fontFamily: 'Open Sans',
                                        cursor: 'pointer',
                                        textDecoration: 'none',
                                        justifyContent: 'center',
                                        textTransform: 'none',
                                        paddingLeft: '3vw',
                                        paddingRight: '3vw',
                                        paddingTop: '6px',
                                        paddingBottom: '6px',
                                        marginTop: '1vw',
                                        width: '10vw'
                                    }}
                                    onClick={closePasswordPopUp}
                                    >
                                    <span style={{ fontSize: '1vw' }}>Back</span>
                                    </button>


                                </div>
                                
                                
                        </div>
                    
                    </div>
            </ServiceDialog>
    )

} 

export default SimpleLoginPopUp;